'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorStyleChange = exports.editorStateChanged = undefined;

var _editorConstants = require('./editorConstants');

var editorStateChanged = exports.editorStateChanged = function editorStateChanged(_ref) {
    var editorId = _ref.editorId,
        editorState = _ref.editorState;
    return {
        type: _editorConstants.EDITOR_STATE_CHANGED,
        editorId: editorId,
        editorState: editorState
    };
}; // Constants
var editorStyleChange = exports.editorStyleChange = function editorStyleChange(_ref2) {
    var styleCommand = _ref2.styleCommand,
        selection = _ref2.selection;
    return {
        type: _editorConstants.EDITOR_STYLE_COMMAND,
        styleCommand: styleCommand,
        selection: selection
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/editorActions.js
// module id = 690
// module chunks = 0